import _ from "lodash";
import {
    INSTAGRAM_IMAGE_SIZE_1_TO_1,
    INSTAGRAM_IMAGE_SIZE_4_TO_5,
    INSTAGRAM_IMAGE_SIZE_ORIGINAL, INSTAGRAM_IMAGE_SIZE_ORIGINAL_4_TO_5,
    LOGO_IMAGE_DETAIL,
    PRODUCT_IMAGE_DETAIL,
    SHOPIFY_PRODUCT_IMAGES_PATH
} from "../constants/shopify.constant";

export {
    applyProductImageSettings,
    getImageContainer,
}

const applyProductImageSettings = (settings, productDetail) => {
    _.forEach(productDetail?.images, (productImage, index) => {
        prepareProductImageProps(productImage, settings);
        productImageFileName(productImage, productDetail, index + 1);
        productImage.instagram = productImage.hasOwnProperty('instagram') ? productImage.instagram : true;
    });
}

const productImageFileName = (productImage, productDetail, productImageIndex) => {
    const filePath = [];
    filePath.push(_.kebabCase(SHOPIFY_PRODUCT_IMAGES_PATH));
    filePath.push(_.kebabCase(productImage.productId));
    filePath.push(productDetail?.handle + '-' + productImageIndex + '-' + productImage.id + '.jpg');
    productImage.imageFilePath = _.join(_.compact(filePath), '/');
    productImage.imageIndex = productImageIndex;
}

const prepareProductImageProps = (productImage, settings) => {
    const imageProps: any = {};
    imageProps.x = 0;
    imageProps.y = 0;

    const productConfig = settings.product;

    fitImage(productImage, imageProps, productConfig, settings);
    imageProps.fillPatternRotation = productConfig.fillPatternRotation;

    productImage.props = imageProps;
}

const fitImage = (productImage, imageProps, productConfig, settings) => {
    let fillPatternScale = settings?.height / productImage?.height;

    if (productConfig.fit === 'height') {
        fillPatternScale = settings?.height / productImage?.height;
    } else if (productConfig.fit === 'width') {
        fillPatternScale = settings?.width / productImage?.width;
    }

    imageProps.fillPatternScaleX = fillPatternScale;
    imageProps.fillPatternScaleY = fillPatternScale;
    imageProps.width = productImage?.width * fillPatternScale;
    imageProps.height = productImage?.height * fillPatternScale;

    if (productConfig.fit === 'width') {
        imageProps.y = (settings?.height - imageProps?.height) / 2;
    } else if (productConfig.fit === 'height') {
        imageProps.x = (settings?.width - imageProps?.width) / 2;
    }

    imageProps.fillPatternOffsetX = -(imageProps.width * productConfig.fillPatternOffsetXPercentage / 100);
    imageProps.fillPatternOffsetY = (imageProps.height * productConfig.fillPatternOffsetYPercentage / 100);
}

const getImageContainer = (selectedImageTabKey) => {
    let imageContainer = INSTAGRAM_IMAGE_SIZE_ORIGINAL;

    if (selectedImageTabKey === 'vertical') {
        imageContainer = INSTAGRAM_IMAGE_SIZE_4_TO_5;
    } else if (selectedImageTabKey === 'squared') {
        imageContainer = INSTAGRAM_IMAGE_SIZE_1_TO_1;
    } else if (selectedImageTabKey === 'original-vertical') {
        imageContainer = INSTAGRAM_IMAGE_SIZE_ORIGINAL_4_TO_5;
    }

    return imageContainer;
}
